import _definePage_default_0 from '/build/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/build/src/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from '/build/src/pages/account-settings/[tab].vue?definePage&vue'
import _definePage_default_4 from '/build/src/pages/confirm-account-deletion.vue?definePage&vue'
import _definePage_default_5 from '/build/src/pages/dashboard/index.vue?definePage&vue'
import _definePage_default_6 from '/build/src/pages/forgot-password.vue?definePage&vue'
import _definePage_default_7 from '/build/src/pages/legal-disclosure.vue?definePage&vue'
import _definePage_default_8 from '/build/src/pages/login.vue?definePage&vue'
import _definePage_default_9 from '/build/src/pages/logout.vue?definePage&vue'
import _definePage_default_10 from '/build/src/pages/meetmaryjane/index.vue?definePage&vue'
import _definePage_default_11 from '/build/src/pages/password-reset.vue?definePage&vue'
import _definePage_default_12 from '/build/src/pages/register.vue?definePage&vue'
import _definePage_default_13 from '/build/src/pages/setup-wizard/index.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('/build/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/build/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/account-settings',
    /* internal name: 'account-settings' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':tab',
        name: 'account-settings-tab',
        component: () => import('/build/src/pages/account-settings/[tab].vue'),
        /* no children */
      },
  _definePage_default_3
  )
    ],
  },
  {
    path: '/automation',
    name: 'automation',
    component: () => import('/build/src/pages/automation.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/confirm-account-deletion',
    name: 'confirm-account-deletion',
    component: () => import('/build/src/pages/confirm-account-deletion.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  {
    path: '/dashboard',
    /* internal name: 'dashboard' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'dashboard',
        component: () => import('/build/src/pages/dashboard/index.vue'),
        /* no children */
      },
  _definePage_default_5
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/build/src/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_6
  ),
  {
    path: '/growing',
    name: 'growing',
    component: () => import('/build/src/pages/growing.vue'),
    /* no children */
  },
  {
    path: '/guides',
    /* internal name: 'guides' */
    /* no component */
    children: [
      {
        path: 'growing',
        /* internal name: 'guides-growing' */
        /* no component */
        children: [
          {
            path: 'grow-medium',
            name: 'guides-growing-grow-medium',
            component: () => import('/build/src/pages/guides/growing/grow-medium.vue'),
            /* no children */
          },
          {
            path: 'grow-mediums-:id',
            name: 'guides-growing-grow-mediums-id',
            component: () => import('/build/src/pages/guides/growing/grow-mediums-[id].vue'),
            /* no children */
          },
          {
            path: 'grow-phases',
            name: 'guides-growing-grow-phases',
            component: () => import('/build/src/pages/guides/growing/grow-phases.vue'),
            /* no children */
          },
          {
            path: 'grow-phases-:id',
            name: 'guides-growing-grow-phases-id',
            component: () => import('/build/src/pages/guides/growing/grow-phases-[id].vue'),
            /* no children */
          },
          {
            path: 'increasing-yield',
            name: 'guides-growing-increasing-yield',
            component: () => import('/build/src/pages/guides/growing/increasing-yield.vue'),
            /* no children */
          },
          {
            path: 'increasing-yield-:id',
            name: 'guides-growing-increasing-yield-id',
            component: () => import('/build/src/pages/guides/growing/increasing-yield-[id].vue'),
            /* no children */
          },
          {
            path: 'nutrients',
            name: 'guides-growing-nutrients',
            component: () => import('/build/src/pages/guides/growing/nutrients.vue'),
            /* no children */
          },
          {
            path: 'nutrients-:id',
            name: 'guides-growing-nutrients-id',
            component: () => import('/build/src/pages/guides/growing/nutrients-[id].vue'),
            /* no children */
          },
          {
            path: 'plant-training',
            name: 'guides-growing-plant-training',
            component: () => import('/build/src/pages/guides/growing/plant-training.vue'),
            /* no children */
          },
          {
            path: 'plant-trainings-:id',
            name: 'guides-growing-plant-trainings-id',
            component: () => import('/build/src/pages/guides/growing/plant-trainings-[id].vue'),
            /* no children */
          },
          {
            path: 'strain-selection',
            name: 'guides-growing-strain-selection',
            component: () => import('/build/src/pages/guides/growing/strain-selection.vue'),
            /* no children */
          },
          {
            path: 'strain-selections-:id',
            name: 'guides-growing-strain-selections-id',
            component: () => import('/build/src/pages/guides/growing/strain-selections-[id].vue'),
            /* no children */
          },
          {
            path: 'troubleshooting',
            name: 'guides-growing-troubleshooting',
            component: () => import('/build/src/pages/guides/growing/troubleshooting.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'harvesting',
        /* internal name: 'guides-harvesting' */
        /* no component */
        children: [
          {
            path: 'curing',
            name: 'guides-harvesting-curing',
            component: () => import('/build/src/pages/guides/harvesting/curing.vue'),
            /* no children */
          },
          {
            path: 'curing-:id',
            name: 'guides-harvesting-curing-id',
            component: () => import('/build/src/pages/guides/harvesting/curing-[id].vue'),
            /* no children */
          },
          {
            path: 'drying',
            name: 'guides-harvesting-drying',
            component: () => import('/build/src/pages/guides/harvesting/drying.vue'),
            /* no children */
          },
          {
            path: 'drying-:id',
            name: 'guides-harvesting-drying-id',
            component: () => import('/build/src/pages/guides/harvesting/drying-[id].vue'),
            /* no children */
          },
          {
            path: 'post-processing',
            /* internal name: 'guides-harvesting-post-processing' */
            /* no component */
            children: [
              {
                path: 'drinkables',
                name: 'guides-harvesting-post-processing-drinkables',
                component: () => import('/build/src/pages/guides/harvesting/post-processing/drinkables.vue'),
                /* no children */
              },
              {
                path: 'drinkables-:id',
                name: 'guides-harvesting-post-processing-drinkables-id',
                component: () => import('/build/src/pages/guides/harvesting/post-processing/drinkables-[id].vue'),
                /* no children */
              },
              {
                path: 'edibles',
                name: 'guides-harvesting-post-processing-edibles',
                component: () => import('/build/src/pages/guides/harvesting/post-processing/edibles.vue'),
                /* no children */
              },
              {
                path: 'edibles-:id',
                name: 'guides-harvesting-post-processing-edibles-id',
                component: () => import('/build/src/pages/guides/harvesting/post-processing/edibles-[id].vue'),
                /* no children */
              },
              {
                path: 'extractions',
                name: 'guides-harvesting-post-processing-extractions',
                component: () => import('/build/src/pages/guides/harvesting/post-processing/extractions.vue'),
                /* no children */
              },
              {
                path: 'extractions-:id',
                name: 'guides-harvesting-post-processing-extractions-id',
                component: () => import('/build/src/pages/guides/harvesting/post-processing/extractions-[id].vue'),
                /* no children */
              },
              {
                path: 'storage',
                name: 'guides-harvesting-post-processing-storage',
                component: () => import('/build/src/pages/guides/harvesting/post-processing/storage.vue'),
                /* no children */
              },
              {
                path: 'storages-:id',
                name: 'guides-harvesting-post-processing-storages-id',
                component: () => import('/build/src/pages/guides/harvesting/post-processing/storages-[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'time-to-harvest',
            name: 'guides-harvesting-time-to-harvest',
            component: () => import('/build/src/pages/guides/harvesting/time-to-harvest.vue'),
            /* no children */
          },
          {
            path: 'time-to-harvest-:id',
            name: 'guides-harvesting-time-to-harvest-id',
            component: () => import('/build/src/pages/guides/harvesting/time-to-harvest-[id].vue'),
            /* no children */
          },
          {
            path: 'trimming',
            name: 'guides-harvesting-trimming',
            component: () => import('/build/src/pages/guides/harvesting/trimming.vue'),
            /* no children */
          },
          {
            path: 'trimming-:id',
            name: 'guides-harvesting-trimming-id',
            component: () => import('/build/src/pages/guides/harvesting/trimming-[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'setting-up',
        /* internal name: 'guides-setting-up' */
        /* no component */
        children: [
          {
            path: 'cutting-costs',
            name: 'guides-setting-up-cutting-costs',
            component: () => import('/build/src/pages/guides/setting-up/cutting-costs.vue'),
            /* no children */
          },
          {
            path: 'cutting-costs-:id',
            name: 'guides-setting-up-cutting-costs-id',
            component: () => import('/build/src/pages/guides/setting-up/cutting-costs-[id].vue'),
            /* no children */
          },
          {
            path: 'grow-automation',
            name: 'guides-setting-up-grow-automation',
            component: () => import('/build/src/pages/guides/setting-up/grow-automation.vue'),
            /* no children */
          },
          {
            path: 'grow-automations-:id',
            name: 'guides-setting-up-grow-automations-id',
            component: () => import('/build/src/pages/guides/setting-up/grow-automations-[id].vue'),
            /* no children */
          },
          {
            path: 'indoor-and-outdoors-:id',
            name: 'guides-setting-up-indoor-and-outdoors-id',
            component: () => import('/build/src/pages/guides/setting-up/indoor-and-outdoors-[id].vue'),
            /* no children */
          },
          {
            path: 'indoor-vs-outdoor',
            name: 'guides-setting-up-indoor-vs-outdoor',
            component: () => import('/build/src/pages/guides/setting-up/indoor-vs-outdoor.vue'),
            /* no children */
          },
          {
            path: 'legal',
            name: 'guides-setting-up-legal',
            component: () => import('/build/src/pages/guides/setting-up/legal.vue'),
            /* no children */
          },
          {
            path: 'legals-:id',
            name: 'guides-setting-up-legals-id',
            component: () => import('/build/src/pages/guides/setting-up/legals-[id].vue'),
            /* no children */
          },
          {
            path: 'planning',
            name: 'guides-setting-up-planning',
            component: () => import('/build/src/pages/guides/setting-up/planning.vue'),
            /* no children */
          },
          {
            path: 'plannings-:id',
            name: 'guides-setting-up-plannings-id',
            component: () => import('/build/src/pages/guides/setting-up/plannings-[id].vue'),
            /* no children */
          },
          {
            path: 'shopping-lists',
            name: 'guides-setting-up-shopping-lists',
            component: () => import('/build/src/pages/guides/setting-up/shopping-lists.vue'),
            /* no children */
          },
          {
            path: 'shopping-lists-:id',
            name: 'guides-setting-up-shopping-lists-id',
            component: () => import('/build/src/pages/guides/setting-up/shopping-lists-[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/harvesting',
    name: 'harvesting',
    component: () => import('/build/src/pages/harvesting.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/legal-disclosure',
    name: 'legal-disclosure',
    component: () => import('/build/src/pages/legal-disclosure.vue'),
    /* no children */
  },
  _definePage_default_7
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/build/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_8
  ),
  _mergeRouteRecord(
  {
    path: '/logout',
    name: 'logout',
    component: () => import('/build/src/pages/logout.vue'),
    /* no children */
  },
  _definePage_default_9
  ),
  {
    path: '/meetmaryjane',
    /* internal name: 'meetmaryjane' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'meetmaryjane',
        component: () => import('/build/src/pages/meetmaryjane/index.vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/my',
    /* internal name: 'my' */
    /* no component */
    children: [
      {
        path: 'environments',
        name: 'my-environments',
        component: () => import('/build/src/pages/my/environments.vue'),
        /* no children */
      },
      {
        path: 'friends',
        name: 'my-friends',
        component: () => import('/build/src/pages/my/friends.vue'),
        /* no children */
      },
      {
        path: 'grow-cycles',
        name: 'my-grow-cycles',
        component: () => import('/build/src/pages/my/grow-cycles.vue'),
        /* no children */
      },
      {
        path: 'inventory',
        /* internal name: 'my-inventory' */
        /* no component */
        children: [
          {
            path: 'equipment',
            name: 'my-inventory-equipment',
            component: () => import('/build/src/pages/my/inventory/equipment.vue'),
            /* no children */
          },
          {
            path: 'seeds',
            name: 'my-inventory-seeds',
            component: () => import('/build/src/pages/my/inventory/seeds.vue'),
            /* no children */
          },
          {
            path: 'supplies',
            name: 'my-inventory-supplies',
            component: () => import('/build/src/pages/my/inventory/supplies.vue'),
            /* no children */
          },
          {
            path: 'tools',
            name: 'my-inventory-tools',
            component: () => import('/build/src/pages/my/inventory/tools.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'plants',
        name: 'my-plants',
        component: () => import('/build/src/pages/my/plants.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/other',
    /* internal name: 'other' */
    /* no component */
    children: [
      {
        path: 'blog',
        name: 'other-blog',
        component: () => import('/build/src/pages/other/blog.vue'),
        /* no children */
      },
      {
        path: 'models',
        name: 'other-models',
        component: () => import('/build/src/pages/other/models.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/password-reset',
    name: 'password-reset',
    component: () => import('/build/src/pages/password-reset.vue'),
    /* no children */
  },
  _definePage_default_11
  ),
  {
    path: '/recipes',
    name: 'recipes',
    component: () => import('/build/src/pages/recipes.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/build/src/pages/register.vue'),
    /* no children */
  },
  _definePage_default_12
  ),
  {
    path: '/setting-up',
    name: 'setting-up',
    component: () => import('/build/src/pages/setting-up.vue'),
    /* no children */
  },
  {
    path: '/setup-wizard',
    /* internal name: 'setup-wizard' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'setup-wizard',
        component: () => import('/build/src/pages/setup-wizard/index.vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  }
]
